import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import '../../components/client/PhoneInput.css';
import ClientLayout from '../../layouts/ClientLayout';


const Checkout = () => {
  // Données du panier (normalement récupérées depuis le contexte ou les props)
  const cartItems = [
    {
      id: 1,
      image: "/images/product4.jpg",
      name: "Chaise d'intérieur Space Gray (9th Generation)",
      price: 120500,
      quantity: 2,
      total: 241000
    },
    {
      id: 2,
      image: "/images/product4.jpg",
      name: "Chaise d'intérieur Space Gray (9th Generation)",
      price: 120500,
      quantity: 2,
      total: 241000
    }
  ];

  // État pour les champs de formulaire
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    company: '',
    email: '',
    city: '',
    neighborhood: ''
  });

  const [phoneNumber, setPhoneNumber] = useState('+228');
  const [couponCode, setCouponCode] = useState('');
  const [shippingAddress, setShippingAddress] = useState("Villa Le Colombier 289, rue Wezu Angle rue Bekpo Lomé (Tokoin Hôpital) - Togo.");
  const [deliveryMode, setDeliveryMode] = useState('shipping'); // 'pickup' ou 'shipping'
  const [isAddressModalVisible, setIsAddressModalVisible] = useState(false);

  // Calculs
  const subtotal = cartItems.reduce((sum, item) => sum + item.total, 0);
  const shippingCost = deliveryMode === 'pickup' ? 0 : 10500;
  const total = subtotal + shippingCost;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const applyCoupon = () => {
    console.log('Coupon appliqué:', couponCode);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Formulaire soumis:', { ...formData, phoneNumber });
  };

  const showAddressModal = () => {
    setIsAddressModalVisible(true);
  };

  const handleAddressModalOk = () => {
    setIsAddressModalVisible(false);
  };

  const handleAddressModalCancel = () => {
    setIsAddressModalVisible(false);
  };

  const handleDeliveryModeChange = (e) => {
    setDeliveryMode(e.target.value);
  };

  const addNewAddress = () => {
    console.log('Ajouter une nouvelle adresse');
    // Ici vous pouvez implémenter la logique pour ajouter une nouvelle adresse
  };

  return (
    <ClientLayout>
      <div className="flex-1 md:mx-8 lg:mx-16 mx-auto py-8">
        {/* Fil d'Ariane */}
        <div className="mb-8">
          <nav className="text-sm text-gray-600">
            <Link to="/" className="hover:text-gray-900">Accueil</Link>
            <span className="mx-2">&gt;</span>
            <Link to="/cart" className="hover:text-gray-900">Panier</Link>
            <span className="mx-2">&gt;</span>
            <span className="text-gray-900">Passer à la caisse</span>
          </nav>
        </div>

        {/* Section Code Promo */}
        <div className="mb-8">
          <div className="bg-gray-50 rounded-lg p-4 flex items-center gap-3">
            <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
            </svg>
            <span className="text-gray-700 font-semibold">Vous avez un code promo ? Cliquez ici pour saisir votre code.</span>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Section Détails de facturation - 2/3 de la largeur */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-lg">
              <h2 className="font-bold text-gray-900 mb-6">Détails de facturation</h2>
              
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Prénom */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Prénom*
                    </label>
                    <input
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      placeholder="Prénom"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none"
                    />
                  </div>

                  {/* Nom de famille */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Nom de famille*
                    </label>
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      placeholder="Nom de famille"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none"
                    />
                  </div>

                  {/* Nom de l'entreprise */}
                  <div className='col-span-2'>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Nom de l'entreprise (facultatif)
                    </label>
                    <input
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleInputChange}
                      placeholder="Nom de l'entreprise"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none"
                    />
                  </div>

                  {/* Email */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Adresse électronique (Facultatif)
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Sélectionner"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none"
                    />
                  </div>

                  {/* Téléphone */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Numéro de téléphone
                    </label>
                    <PhoneInput
                      international
                      defaultCountry="TG"
                      value={phoneNumber}
                      onChange={setPhoneNumber}
                      placeholder="Entrez votre numéro"
                      className="w-full px-4 py-1.5 pr-0 border rounded-lg bg-gray-50 focus:border-transparent"
                    />
                  </div>

                  {/* Ville */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Ville*
                    </label>
                    <select
                      name="city"
                      value={formData.city}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none"
                    >
                      <option value="">Sélectionner</option>
                      <option value="lome">Lomé</option>
                      <option value="kara">Kara</option>
                      <option value="sokode">Sokodé</option>
                      <option value="kpalime">Kpalimé</option>
                    </select>
                  </div>

                  {/* Quartier */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Quartier*
                    </label>
                    <select
                      name="neighborhood"
                      value={formData.neighborhood}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none"
                    >
                      <option value="">Sélectionner</option>
                      <option value="tokoin">Tokoin</option>
                      <option value="be">Bé</option>
                      <option value="akodessewa">Akodessewa</option>
                      <option value="adidogome">Adidogomé</option>
                    </select>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* Section Totaux - 1/3 de la largeur */}
          <div className="lg:col-span-1">
            <div className="bg-gray-50 rounded-lg p-6 sticky top-8">
              <h2 className="text-lg font-bold text-gray-900 mb-6">TOTAUX DU PANIER</h2>
              
              {/* Détails des coûts */}
              <div className="space-y-4 mb-6">
                <div className="flex justify-between border-b border-gray-300 pb-4">
                  <span className="text-gray-400">Total produit</span>
                  <span className="font-medium">{subtotal.toLocaleString()} Fcfa</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-400">Frais d'expédition</span>
                  <span className="font-medium">{shippingCost.toLocaleString()} Fcfa</span>
                </div>
              </div>

              {/* Adresse de livraison */}
              <div className="mb-6 p-4 rounded-lg text-right">
                <h3 className="font-medium text-gray-900 mb-2">Adresse de livraison</h3>
                <p className="text-sm text-gray-600 mb-2">
                  {deliveryMode === 'pickup' 
                    ? 'Point de Retrait Kilimmanjaro - Entrepôt'
                    : `Expédition vers ${shippingAddress}`
                  }
                </p>
                <button 
                  onClick={showAddressModal}
                  className="text-orange-hover text-sm hover:text-orange-700 underline text-right"
                >
                  Changer d'adresse
                </button>
              </div>

              {/* Total final */}
              <div className="border-t pt-4 mb-6">
                <div className="flex justify-between items-center">
                  <span className="text-base text-gray-400">Total</span>
                  <span className="text-lg font-bold text-gray-900">{total.toLocaleString()} Fcfa</span>
                </div>
              </div>

              {/* Bouton passer à la caisse */}
              <Link to="/checkout/success">
                <button className="w-full bg-orange-light text-white py-3 px-6 rounded-full hover:bg-orange-hover transition-colors">
                  Passer à la commande
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </ClientLayout>
  );
};

export default Checkout; 